import { PropsWithChildren, Suspense } from 'react';
import { Badge } from '@givebutter/primitives/badge';
import { Loader } from '@givebutter/primitives/loader';
import { faArchive } from '@fortawesome/pro-regular-svg-icons';
import { faHouse } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { usePossibleCurrentContactHousehold } from 'customHooks/useCurrentContactHousehold';
import { isoDateFromServer } from 'helpers/dates';
import { DateTime } from 'luxon';

const ContactInfoHeader = () => {
    const { data: contact } = useCurrentContact();
    const isArchived = !!contact.archived_at;

    return (
        <div className={'flex items-center gap-3'}>
            {contact && (
                <p className={'text-base text-gray-700'}>
                    Contact since{' '}
                    {isoDateFromServer(contact.created_at).toLocaleString(DateTime.DATE_FULL)}
                </p>
            )}
            {isArchived && (
                <Badge color="warning">
                    <FontAwesomeIcon icon={faArchive} />
                    <p>Archived</p>
                </Badge>
            )}
        </div>
    );
};

const ContactHouseholdBadge = () => {
    const { data: household } = usePossibleCurrentContactHousehold();

    if (!household) {
        return null;
    }

    return (
        <Badge>
            <FontAwesomeIcon size={'sm'} icon={faHouse} />
            <p className={'font-medium'}>{household.name}</p>
        </Badge>
    );
};

const ContactHeader = ({ children }: PropsWithChildren) => {
    return (
        <div className={'flex flex-col gap-1'}>
            <div className={'flex items-center gap-4'}>
                <h1 className={'flex items-center gap-2 text-3xl font-medium'}>{children}</h1>
                <Suspense fallback={<Loader />}>
                    <ContactHouseholdBadge />
                </Suspense>
            </div>
            <ContactInfoHeader />
        </div>
    );
};

export { ContactHeader, ContactInfoHeader };
